import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useReturnLabelRowStyle = makeStyles((theme: Theme) => ({
  smallColumn: {
    width: theme.spacing(19),
  },
  cartonName: {
    fontWeight: 700,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  button: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    borderRadius: theme.spacing(4),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: 'rgba(0, 0, 0)',
    textOverflow: 'ellipsis',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
}));
